var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#333D4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6V22L8 18L16 22L23 18V2L16 6L8 2L1 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6V22"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.38cc1f16995366402541f07ecdac036d.svg";
export { ForwardRef as ReactComponent };